export enum SystemFeature {
  Payroll = 46,
  AssetTracker = 80,
  Paylocity = 85,
  CobraTransmission = 87,
  CriticalNewsFeed = 114,
  MotivHealth = 121,
  SameraHealth = 122
}

export enum SystemSetting {
  EmployeeReferral = 2301,
  ProfitSharing = 2307
}

export enum AppPermission {
  BenefitsAccess = 6051,
  MeetingNotesView = 10001,
  MeetingNotesEdit = 10002,
  MeetingNotesMaster = 3212,
  CredentialTransitionsManage = 3148,
  CredentialTransitionsView = 3149,
  CredentialTransitionsEdit = 3150,
  PayrollApprovalApprove = 154,
  PayrollApprovalViewAll = 3022,
  PayrollApprovalShowAllItems = 3069,
  PayrollApprovalViewAssigned = 3120,
  PayrollApprovalEditItems = 3126,
  PayrollApprovalViewMainCampus = 6030,
  HRPortalReimbursementsHRApproval = 12008,
  HRPortalReimbursementsAAInitialApproval = 12009,
  HRPortalReimbursementTypesView = 12010,
  HRPortalReimbursementTypesEdit = 12011,
  LittleTiffUse = 12001
}
